export default __webpack_public_path__ + "static/media/vision.b99709cd.jpg";